import { fetch } from '../'

export default {
  async get (menu = 'menu') {
    let response = await fetch(`/wp-json/wpvue/v1/menu/${menu}${window.lang ? '?lang=' + window.lang : ''}`)
    let data = await response.json()
    return response.ok ? data : []
  }
}
